import type { Device } from "@strtmn/sds/types"
import { useContext } from "react"
import { useRouteLoaderData } from "react-router-dom"
import { isProd } from "../config"
import { UserDataContext, UserDataContextHelper } from "../contexts"
import type { EnrichedMachineSupa } from "../routes/vehicles/VehiclesListPage"
import { useActiveOrgId } from "./useActiveOrgId"

export const useMachineFromUserCtx = (
  vin: string
): EnrichedMachineSupa | undefined => {
  const { userData } = useContext(UserDataContext)
  const activeOrgId = useActiveOrgId()
  const vehiclesFromDdb = useRouteLoaderData("vehicles-page") as Device[]
  !isProd &&
    console.debug(
      `${vehiclesFromDdb.length} vehicles from loader:`,
      vehiclesFromDdb
    )
  let filteredItems: EnrichedMachineSupa[] = []
  if (activeOrgId && userData) {
    const org = UserDataContextHelper.findOrg(activeOrgId, userData)
    const machinesFromUserCtx = org.Machines
    !isProd &&
      console.debug(
        `${machinesFromUserCtx.length} machines from userData:`,
        machinesFromUserCtx
      )

    // Filtering is not required, as the list from UserCtx is already for the current org.
    // const filteredItems = filterDevices(items, activeOrgId)

    // Merge data from supa (machine meta data) and ddb (presence)
    filteredItems = machinesFromUserCtx.map((supa) => {
      // Match against `seriennummer`, as this should be unique, and m_fahrgestellnummer is not
      const matchingVehicle = vehiclesFromDdb.find(
        (device) =>
          device["seriennummer"] ===
          supa.modem_serial /*||device["m_fahrgestellnummer"] === supa.serial_number*/
      )
      return {
        ...supa,
        vehicleFromDdb: matchingVehicle,
      }
    })
  }

  const enrichedMachineSupa = filteredItems.find((item) => {
    const _vehicleFromDdb = item.vehicleFromDdb
    const _vin = item.serial_number || _vehicleFromDdb?.vin
    return _vin === vin
  })

  return enrichedMachineSupa
}
